import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getSMCCallData } from '@shared/models/adobe-tags';
import { SmcResponseMessageEnum, SmcTemplateKeysDict } from '@shared/models/smc-templates';
import { environment } from '@src/environments';
import * as fromRootStore from '@store/index';
import { TrackSMCCallToAction } from '@store/index';
import { ButtonModule } from '@vg-constellation/angular-16/button';

import { getConfigClientFromRTE } from '../../../core/config/config-client';
import { LoggerCodes, LoggerService } from '../../modules/logger/logger';
import { SmcButtonContent } from '../../services/content/content-jsons/smc-button-internal-content';

@Component({
  selector: 'app-smc-button',
  templateUrl: './smc-button.component.html',
  styleUrls: ['./smc-button.component.scss'],
  standalone: true,
  imports: [ButtonModule],
})
export class SmcButtonComponent implements OnInit {
  @Input() template: string;
  templateContent: any;

  smcMessagesSent: any = {};
  content = SmcButtonContent;
  config: any;

  constructor(
    private httpClient: HttpClient,
    private globalStore: Store<fromRootStore.State>,
    protected logger: LoggerService,
  ) {}

  ngOnInit() {
    this.config = getConfigClientFromRTE();
    this.templateContent = this.content.templates[this.template];
    this.smcMessagesSent = this.templateContent.sections.reduce(
      (acc, section) => ({ ...acc, [section.smcTemplateKey]: false }),
      {},
    );
  }

  sendSecureMessage(smcTemplateKey: string) {
    this.httpClient.post<any>(`secure/sendsmcapi`, { payload: smcTemplateKey }).subscribe(
      (data) => {
        const smcSent = data.statusMessage === SmcResponseMessageEnum.SUCCESS_MSG;

        if (smcSent) {
          this.smcMessagesSent[smcTemplateKey] = true;

          const adobeKey = SmcTemplateKeysDict[smcTemplateKey];

          this.httpClient.get(`secure/spoids`).subscribe((spoids) => {
            this.adobeTrack(smcTemplateKey, spoids, adobeKey);
          });
        }
      },
      (error) => {
        this.logger.error(
          { message: 'Internal SMC call failed: ' + error },
          LoggerCodes.SECURE_MESSAGE_INTERNAL_FAILURE,
        );
      },
    );
  }

  adobeTrack(smcTemplateKey: string, spoids: any, adobeKey: string) {
    try {
      const data = getSMCCallData(smcTemplateKey, spoids, adobeKey);

      this.globalStore.dispatch(TrackSMCCallToAction(data));

      this.logger.log({
        eventId: 'SMC success',
        sPOID: spoids.clientSpoid,
        crewSPOID: spoids.crewSpoid,
      });
    } catch (e) {
      this.logger.error(
        { message: 'Failed adobe tracking for internal smc button: ' + e },
        LoggerCodes.SECURE_MESSAGE_INTERNAL_ADOBE_FAILURE,
      );
    }
  }
}
